import React from 'react';
import { useI18n } from 'react-simple-i18n';

export default function NotFoundView() {
	const { t } = useI18n();

	return <div>{t('view404.title')}</div>;
}
